import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  TextInput,
  SelectInput,
} from "../../components/common/UI/Inputs/InputControls";
import DatePickerComponent from "../../components/common/UI/Inputs/InputControls/DateInput.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import { sendPhotosActions, myContactsActions, archivedActions } from "../../_store";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import { ReactNotifications } from "react-notifications-component";
import useFullPageLoader from "../../hooks/useFullPageLoader.jsx";
import translations from "../../config/TranslateFile.jsx";
import { sendEcardsActions } from "../../_store/sendEcards.slice.js";
import { EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import messageRead from "../../assets/images/double-tick-indicator.png";
import messagesent from "../../assets/images/tick.png";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";

const SendEcards = () => {
  const userID = getStoredValue("userID");
  const currentLang = translations();
  const defaultParams = {
    publicUserID: userID,
    inmateID: 0,
    ecardSubject: "",
    fromDate: "",
    toDate: "",
    sender: "Public User",
    status: 0,
    pageNo: 0,
    rowCountPerPage: 10,
    sortBy: "",
  };

  const [showSearchFields, setShowSearchFields] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [hasMoreData, setHasMoreData] = useState(true);
  const [pageNo, setPageNo] = useState(1); // Current page number
  const [searchpageNo, setSearchpageNo] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [loadedPages, setLoadedPages] = useState(new Set());
  const [searchloadedPages, setSearchLoadedPages] = useState(new Set());
  const [isPurchaseHistoryConfirm, setIsPurchaseHistoryConfirm] =
    useState(false);
  const [purchaseCreditInmateID, setPurchaseCreditInmateID] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const MsgPhotoStatusResponse = useSelector(
    (state) => state.sendPhotos.CheckingMsgPhotoStatusResponse
  );
  const InmateDrpList = useSelector(
    (x) => x.myContacts.PublicMyContactsDisplayNew
  );
  const { loading } = useSelector((state) => state.sendPhotos);

  // State to store filtered results
  const [filteredEcards, setFilteredEcards] = useState([]);
  const [previousFilteredPhotos, setPreviousFilteredPhotos] = useState([]);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab ? location.state?.activeTab : "Inmate"); // Default to "Sent"

  // Status option for Status
  const StatusOptions = [
    { value: 0, label: currentLang?.DropDown?.All },
    { value: 1, label: currentLang?.DropDown?.Read },
    { value: 2, label: currentLang?.DropDown?.Unread },
  ];

  // Initial state for findPhotos
  const InitialFindEcard = {
    userID: userID,
    InmateID: 0,
    FromDate: "",
    ToDate: "",
    MessageStatus: 0,
    ecardSubject: "", // Ensure this is set to an empty string initially
    Status: 0, // Default to "All"
  };
  const [findEcards, setFindEcards] = useState(InitialFindEcard);
  const [pendingSearch, setPendingSearch] = useState(null);
  const { isSignalRData } = useSelector((state) => state.auth);

  // useEffect(() => {
  //   LoadEcardPhotos(activeTab);
  // }, [activeTab])

  useEffect(() => {
    if (location.state?.findEcards) {
      // Extract and set default search parameters
      const defaultSearchParams = {
        FromDate: location.state.findEcards.FromDate || "",
        InmateID: location.state.findEcards.InmateID || 0,
        ToDate: location.state.findEcards.ToDate || "",
        ecardSubject: location.state.findEcards.ecardSubject || "",
        // StatusOptions: location.state.findEcards.StatusOptions || "",
        Status: location.state.findEcards.Status,
        userID: location.state.findEcards.userID || "",
      };

      // Update state with the merged values
      setFindEcards((prev) => ({
        ...prev,
        ...defaultSearchParams,
      }));

      // Determine selected inmate and handle search logic
      if (Array.isArray(InmateDrpList)) {
        const filteredContacts = InmateDrpList.filter(
          (item) =>
            item.value === parseInt(location.state.findEcards.InmateID, 10)
        );

        if (filteredContacts.length === 1) {
          const data = filteredContacts[0];
          handleSelectChange(data, "InmateID");
          setShowSearchFields(true);
          setPendingSearch({ value: data.value });
          handleSearch(false, data.value);
        } else {
          setShowSearchFields(true);
          setPendingSearch({ value: 0 });
          handleSearch(false, 0);
        }
      }
      else {
        handleSearch(false, 0);
      }
    }
  }, [location.state]);

  // useEffect(() => {
  //   if (pendingSearch !== null) {
  //     handleSearch(false, pendingSearch.value);
  //     setPendingSearch(null); // Reset after execution
  //   }
  // }, [pendingSearch]);

  // Function for Initia
  const LoadEcardPhotos = useCallback(
    async (tab) => {
      try {
        showLoader();
        const response = await dispatch(
          sendEcardsActions.LoadSendEcardList({
            ...defaultParams,
            pageNo: 1,
            append: true,
            sender: tab || activeTab, // use passed tab, not possibly stale activeTab
          })
        );

        if (response.payload && response.payload.length > 0) {
          hideLoader();
          const infoMessage = "Load E-Cards details ";
          const redirectURL = "---";
          const Status = "---";
          const Response = JSON.stringify(response?.payload);
          EventLog(dispatch, infoMessage, redirectURL, Response, Status);
          setFilteredEcards(response.payload);
          setHasMoreData(true);
          if (response.payload.length < defaultParams?.rowCountPerPage) {
            setHasMoreData(false);
          }
        } else {
          setFilteredEcards([])
          hideLoader();
          setHasMoreData(false);
          setIsSearch(true);
        }
      } catch (error) {
        hideLoader();
      }
    },
    [dispatch]
  );

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    LoadEcardPhotos(tabName); // pass the latest tab
    const publicUserId = getStoredValue("userID");
    if (publicUserId) {
      dispatch(
        archivedActions.PULoginUnreadNotificationCount({ publicUserId })
      );
    }
    setIsSearch(false);
    setFindEcards(InitialFindEcard); // Reset findPhotos to initial state
    ResetState();
  };

  const ResetState = () => {
    const updatedState = {
      ...location.state,
      findEcards: undefined,
    };
    // Navigate to the current path with the updated state
    navigate(location.pathname, { state: updatedState });
    storeCurrentRoute(location.pathname);
  };

  // Helper function to validate the date
  const isValidDate = (date) => {
    return !isNaN(new Date(date).getTime());
  };

  // Handle date input change with validation
  const handleDateChange = (date, field) => {
    // Create a Date object and check if it's valid
    const parsedDate = new Date(date);
    const currentDate = new Date();

    // Check if the year is valid (>= 1990) and date is not in the future
    const isValidYearAndDate =
      isValidDate &&
      parsedDate.getFullYear() >= 1990 &&
      parsedDate <= currentDate;
    const formattedDate =
      date && isValidDate(date) && isValidYearAndDate
        ? new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(new Date(date))
        : null;

    setFindEcards((prev) => {
      const newState = {
        ...prev,
        [field]: formatDate(formattedDate), // If invalid date, set to empty string
      };

      // Validation logic for FromDate and ToDate
      if (field === "FromDate" && newState.FromDate && newState.ToDate) {
        const fromDateObj = new Date(newState.FromDate);
        const toDateObj = new Date(newState.ToDate);
        if (fromDateObj > toDateObj) {
          newState.FromDate = ""; // Reset FromDate if it's greater than ToDate
        }
      }

      if (field === "ToDate" && newState.ToDate && newState.FromDate) {
        const fromDateObj = new Date(newState.FromDate);
        const toDateObj = new Date(newState.ToDate);
        if (toDateObj < fromDateObj) {
          newState.ToDate = ""; // Reset ToDate if it's less than FromDate
        }
      }

      return newState;
    });
  };

  const formatDateTime = (date) => {
    if (date !== null) {
      const d = new Date(date);

      const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero if necessary
      const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero if necessary
      const year = d.getFullYear(); // Get the full year

      let hours = d.getHours(); // Get the hours (24-hour format)
      const minutes = String(d.getMinutes()).padStart(2, "0"); // Get the minutes and pad with leading zero if necessary
      const ampm = hours >= 12 ? "PM" : "AM"; // Determine if AM or PM
      hours = hours % 12; // Convert to 12-hour format
      hours = hours ? hours : 12; // Handle the case where 0 hours is converted to 12

      return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`; // Return the formatted date and time
    } else {
      return null;
    }
  };

  const formatDate = (date) => {
    if (date !== null) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero if necessary
      const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero if necessary
      const year = d.getFullYear(); // Get the full year
      return `${month}/${day}/${year}`; // Return the formatted date
    } else {
      return null;
    }
  };

  // OnBlur validation for FromDate and ToDate
  const handleBlur = (e, field) => {
    let { value } = e.target;
    const minDate = field === "ToDate" && findEcards?.FromDate ? new Date(findEcards.FromDate) : new Date(2017, 0, 1);

    const maxDate = field === "FromDate" && findEcards?.ToDate && findEcards?.ToDate !== "" ? new Date(findEcards.ToDate) : new Date();

    const inputDate = new Date(value);
    const fromDateObj = new Date(findEcards?.FromDate);
    const toDateObj = new Date(findEcards?.ToDate);
    const currentDate = new Date();

    // ✅ Clear if input date is invalid or < minDate or > maxDate
    if (!value || isNaN(inputDate.getTime()) || inputDate < minDate || inputDate > maxDate) {
      setFindEcards((prev) => ({ ...prev, [field]: "" }));
      return;
    }

    // Check if FromDate and ToDate are valid dates and compare them
    if (
      field === "FromDate" &&
      findEcards?.FromDate &&
      toDateObj &&
      fromDateObj > toDateObj
    ) {
      setFindEcards((prev) => ({ ...prev, FromDate: "" })); // Reset FromDate if invalid
    }

    if (
      field === "ToDate" &&
      findEcards?.ToDate &&
      fromDateObj &&
      toDateObj < fromDateObj
    ) {
      setFindEcards((prev) => ({ ...prev, ToDate: "" })); // Reset ToDate if invalid
    }

    // Year validation for FromDate and ToDate onBlur (ensure year >= 1990 and not in the future)
    const fromDateYear = new Date(findEcards?.FromDate).getFullYear();
    const toDateYear = new Date(findEcards?.ToDate).getFullYear();

    if (fromDateYear < 1990 || new Date(findEcards?.FromDate) > currentDate) {
      setFindEcards((prev) => ({ ...prev, FromDate: "" })); // Reset FromDate if year < 1990 or date in future
    }

    if (toDateYear < 1990 || new Date(findEcards?.ToDate) > currentDate) {
      setFindEcards((prev) => ({ ...prev, ToDate: "" })); // Reset ToDate if year < 1990 or date in future
    }
  };

  const handleCancelPurchaseHist = () => {
    setIsPurchaseHistoryConfirm(false);
  };

  const handleChange = (e, field) => {
    setFindEcards((prev) => ({
      ...prev,
      [field]: e.target.value, // Update the specific field in state
    }));
  };

  const handleSelectChange = (selectedOption, field) => {
    // const updatedValue = selectedOption?.value ?? (field === "Status" ? "1" : 0);

    // Update state immutably
    setFindEcards((prev) => ({
      ...prev,
      [field]: selectedOption?.value ? selectedOption?.value : 0,
    }));

    // Log the immediate new state for verification
    // const newState = { ...findEcards, [field]: updatedValue };
  };

  useEffect(() => {
    let inmatesId = 0;
    // let userID = UserId;
    let userId = getStoredValue("userID");
    let activeStatus = 0;
    let sortField = "InmateName asc";
    let inmateLoadPurpose = "All";
    dispatch(
      myContactsActions.PublicMyContactsDisplayNew({
        userId,
        inmatesId,
        inmateLoadPurpose,
        activeStatus,
        sortField,
      })
    );
  }, [dispatch]);

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleClick = (ecard) => {
    navigate("/public/E-CardViewer", {
      state: { eCardId: ecard, findEcards: findEcards, activeTab: activeTab },
    });
    storeCurrentRoute("/public/E-CardViewer");
  };

  const getStatusString = (statusValue) => {
    switch (statusValue) {
      case "2":
        return "Read";
      case "3":
        return "Unread";
      case "4":
        return "Rejected";
      case "5":
        return "Waiting";
      default:
        return "All"; // For "1" or any unexpected values, treat as "All"
    }
  };

  const handleLoadMore = async () => {
    // Calculate the new page number
    const newPageNo = pageNo + 1;

    // Check if the page has already been loaded to prevent re-fetching
    if (loadedPages.has(newPageNo)) {
      setHasMoreData(false);
      return;
    }
    try {
      // Fetch new data using dispatch
      const response = await dispatch(
        sendEcardsActions.LoadSendEcardList({
          ...defaultParams,
          pageNo: newPageNo, // Pass the updated page number
          append: true, // Indicate this call is for appending data
          sender: activeTab || "Public User",
        })
      );

      // Handle the response
      if (response.payload && response.payload.length > 0) {
        setFilteredEcards((prev) => [...prev, ...response.payload]); // Append new data to existing data
        const infoMessage = "Load E-Cards details ";
        const redirectURL = "---";
        const Status = "---";
        const Response = JSON.stringify(response?.payload);
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
        // Update loaded pages to prevent fetching the same page again
        setLoadedPages((prevLoadedPages) => {
          const updatedLoadedPages = new Set(prevLoadedPages);
          updatedLoadedPages.add(newPageNo);
          return updatedLoadedPages;
        });

        // Update page number state for future requests
        setPageNo(newPageNo);

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        // Stop loading if no data is returned
        setHasMoreData(false);
      }
    } catch (error) {
      console.error("Error loading more data:", error);
    }
  };

  const handleSearch = async (IsLoadMore, InmateIDFilter) => {
    showLoader();
    // Calculate the new page number
    let newPageNo = 1;
    setIsSearch(true);

    if (IsLoadMore) {
      newPageNo = searchpageNo + 1;
      if (searchloadedPages.has(newPageNo)) {
        setHasMoreData(false);
        return;
      }
    } else {
      setFilteredEcards([]);
      const resetLoadedPages = new Set();
      resetLoadedPages.add(newPageNo); // Add the first page to prevent duplicate fetches
      setSearchLoadedPages(resetLoadedPages);
    }

    // const { InmateID, FromDate, ToDate, Subject, StatusOptions } = findPhotos;
    const { InmateID, FromDate, ToDate, ecardSubject, Status } = findEcards;
    // const statusFilter = getStatusString(StatusOptions); // Convert StatusOptions to the appropriate value

    try {
      // Prepare the request payload based on defaultParams and the search filters
      const requestPayload = {
        ...defaultParams, // Spread the defaultParams to maintain initial values
        InmateID:
          InmateIDFilter !== null && InmateIDFilter != undefined
            ? InmateIDFilter
            : InmateID,
        FromDate:
          FromDate != "" && FromDate != null ? formatDate(FromDate) : "",
        ToDate: ToDate != "" && ToDate != null ? formatDate(ToDate) : "",
        // MessageStatus: statusFilter === "All" ? 0 : StatusOptions, // Adjust MessageStatus based on filter
        Status: Status, // Adjust MessageStatus based on filter
        ecardSubject: ecardSubject,
        pageNo: newPageNo, // Always start with page 1 for the search
        rowCountPerPage: 10, // Set the number of rows per page
      };

      // Call the API to fetch the filtered data
      const response = await dispatch(
        sendEcardsActions.LoadSendEcardList({
          ...requestPayload,
          append: true, // Indicate this is not for appending
          sender: activeTab || "Public User",
        })
      );

      if (response.payload && response.payload.length > 0) {
        hideLoader();
        const infoMessage = "Load E-Cards details ";
        const redirectURL = "---";
        const Status = "---";
        const Response = JSON.stringify(response?.payload);
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
        if (newPageNo === 1) {
          setHasMoreData(true);
          setFilteredEcards([]);
          // Ensure the clearing takes effect before setting new data
          setTimeout(() => {
            setFilteredEcards(response.payload);
          }, 0);
        } else {
          setFilteredEcards((prev) => [...prev, ...response.payload]); // Append new data to existing data
        }

        // Update loaded pages to prevent fetching the same page again
        setSearchLoadedPages((prev) => {
          const updatedSearchLoadedPages = new Set(prev);
          updatedSearchLoadedPages.add(newPageNo);
          return updatedSearchLoadedPages;
        });

        // Update page number state for future requests
        setSearchpageNo(newPageNo); // Increment page number for next load

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        // Stop loading if no data is returned
        setHasMoreData(false);
        hideLoader();
      }
    } catch (error) {
      hideLoader();
      console.error("Error fetching search data:", error);
    }
  };

  // Reset to clear state and show all items
  const handleReset = () => {
    setIsSearch(false);
    setFindEcards(InitialFindEcard); // Reset findPhotos to initial state
    LoadEcardPhotos(activeTab);
    ResetState();
  };

  const handleClickRedirect = (event, InmateID) => {
    event.stopPropagation(); // Prevent event from bubbling up
    setIsPurchaseHistoryConfirm(true);
    setPurchaseCreditInmateID(InmateID);
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };

  useEffect(() => {
    if (!location.state?.findEcards) {
      LoadEcardPhotos();
    }
  }, []);

  // Purchase Credit status checking
  useEffect(() => {
    if (MsgPhotoStatusResponse.length === undefined) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      setIsPurchaseHistoryConfirm(false);
      LoadEcardPhotos();
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ECardPopContent?.Connection_BlockedBY_Admin);
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            if (Result === 0) {
              setStoredValue("InmateID", purchaseCreditInmateID);
              navigate("/public/PurchaseCredits", {
                state: { previousPath: location.pathname },
              });
              storeCurrentRoute("/public/PurchaseCredits");
              dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
            }
          }
          break;
      }
    }
  }, [MsgPhotoStatusResponse]);

  const handleClickPurchaseCreditRedirect = () => {
    showLoader();
    dispatch(
      sendPhotosActions.CheckingMsgPhotoStatus({
        addFormData: { UserID: userID, InmateID: purchaseCreditInmateID },
      })
    ).then((x) => {
      hideLoader();
    })
  };



  return (
    <>
      <ReactNotifications />
      <div>
        <div className="header-title">
          <h5>
            {/* <i className="fa fa-paper-plane me-2"></i> */}
            {currentLang?.EcardHistory}
          </h5>
        </div>
      </div>

      <div className="row mb-5 pb-mobile">
        <div className="col-md-12">
          <ul className="list-group" id="divLoadList">
            <div className="card border-radius-all shadow-sm">
              <div
                className="card-header d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h4 className="mb-0 text-dark">
                  <i
                    className="fa fa-search me-2"
                    style={{ fontSize: "16px" }}
                  ></i>{" "}
                  {currentLang?.header?.Search}
                </h4>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
              {showSearchFields && (
                <div className="card-body bg-white padding-20">
                  <div className="row">
                    {/* Inmate Name */}
                    <div className="col-md-6">
                      <SelectInput
                        options={InmateDrpList}
                        value={findEcards.InmateID}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "InmateID")
                        }
                        name="InmateID"
                        labelKey="label"
                        valueKey="value"
                        isClearable={true}
                        placeholder={currentLang?.placeholders?.cmbInmate}
                        label={currentLang?.labels?.Inmate}
                        required={true}
                        disabled={findEcards.InmateID !== 0} // Disable if an inmate is selected
                      />
                    </div>

                    {/* Subject */}
                    <div className="col-md-6">
                      <TextInput
                        name="ecardSubject"
                        id="Subject"
                        label={currentLang?.labels?.Subject}
                        value={findEcards?.ecardSubject}
                        handleChange={(e) => handleChange(e, "ecardSubject")}
                        placeholder={currentLang?.labels?.Subject}
                        required={false}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearch(false);
                          }
                        }}
                      />
                    </div>

                    {/* From Date */}
                    <div className="col-md-4">
                      <DatePickerComponent
                        value={findEcards?.FromDate}
                        onChange={(date) => handleDateChange(date, "FromDate")}
                        onBlur={(e) => handleBlur(e, "FromDate")}
                        name="FromDate"
                        label={currentLang?.labels?.FromDate}
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        showTimeSelect={false}
                        minDate={new Date(2017, 0, 1)}
                        maxDate={
                          findEcards?.ToDate !== null &&
                            findEcards?.ToDate !== ""
                            ? findEcards?.ToDate
                            : new Date()
                        }
                      />
                    </div>

                    {/* To Date */}
                    <div className="col-md-4">
                      <DatePickerComponent
                        value={findEcards?.ToDate}
                        onChange={(date) => handleDateChange(date, "ToDate")}
                        onBlur={(e) => handleBlur(e, "ToDate")}
                        name="ToDate"
                        label={currentLang?.labels?.ToDate}
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        showTimeSelect={false}
                        minDate={findEcards?.FromDate ? findEcards?.FromDate : new Date(2017, 0, 1)}
                        maxDate={new Date()}
                      />
                    </div>

                    {/* Status */}

                    <div className="col-md-4">
                      <SelectInput
                        options={StatusOptions}
                        value={findEcards?.Status}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "Status")
                        }
                        name="Status"
                        labelKey="label"
                        valueKey="value"
                        isClearable={findEcards?.Status == 0 ? false : true}
                        placeholder=""
                        label={currentLang?.labels?.Status}
                      />
                    </div>

                  </div>

                  <div className="text-center mt-2">
                    <div className="d-flex justify-content-start">
                      <button
                        type="submit"
                        className="btn btn-success me-2"
                        onClick={() => handleSearch(false)}
                      >
                        <i className="fa-solid fa-magnifying-glass me-1"></i>
                        {currentLang?.buttons?.Search}
                      </button>
                      <button
                        type="button"
                        className="btn btn-grey me-2"
                        onClick={handleReset}
                      >
                        <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                        {currentLang?.buttons?.Reset}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* --- TABS FOR SENT / RECEIVED --- */}
            {/* <ul className="nav nav-tabs mt-3" id="ecardTabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "Sent" ? "active" : ""}`}
            onClick={() => setActiveTab("Sent")}
          >
            Sent
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "Received" ? "active" : ""}`}
            onClick={() => setActiveTab("Received")}
          >
            Received
          </button>
        </li>
      </ul> */}
            <ul className="nav nav-tabs border-0 mt-2">
              <li className="nav-item">
                <button
                  className={`nav-link rounded-top ${activeTab === "Inmate"
                    ? "bg-danger text-white"
                    : "text-black bg-white"
                    }`}
                  onClick={() => handleTabClick("Inmate")}
                >
                  <i className="bi bi-inbox-fill me-1"></i>  {currentLang?.Received}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link rounded-top ${activeTab === "Public User"
                    ? "bg-danger text-white"
                    : "text-black bg-white"
                    }`}
                  onClick={() => handleTabClick("Public User")}
                >
                  <i className="bi bi-send-fill me-1"></i> {currentLang?.Sent}
                </button>
              </li>
            </ul>

            <ul
              className="list-group mt-0 border-radius-all shadow-sm"
              id="divLoadList"
            >
              {loading ? (
                <div className="alert alert-info text-center" role="alert">
                  {currentLang?.ArchivedPage?.Loading}
                </div>
              ) : isSearch &&
                filteredEcards?.length === 0 &&
                !previousFilteredPhotos?.length ? (
                <div className="alert-light-red mb-3 font-size-16 p-3 text-center">
                  {currentLang?.info?.NoResult}
                </div>
              ) : (
                filteredEcards?.map((ecard, index) => (
                  <li
                    className="list-group-item d-flex align-items-center justify-content-between flex-wrap cursor-pointer"
                    onClick={() => handleClick(ecard)}
                    key={index}
                  >
                    {/* Photo details */}
                    <div className="d-flex align-items-center message-area-disc m-w-100 mo-mb-10">
                      <i
                        className="fa fa-user-circle fa-2x me-3"
                        aria-hidden="true"
                      ></i>
                      {(ecard?.Sender == "Inmate" && ecard.ReadStaus === "Unread") && (
                        <span
                          className="me-3 notificationBadge animate-blink"
                          style={{
                            position: "absolute",
                            top: "9px",
                            left: "36px",
                            // backgroundColor: "#4a9a93",
                            // color: "#FFFFFF",
                            borderRadius: "50%",
                            fontSize: "10px",
                            fontWeight: "bold",
                            display: "flex",
                            width: "22px",
                            height: "22px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          1
                        </span>
                      )}
                      <div>
                        <label className="fw-bold mb-0 profile-Name">
                          {activeTab === "Public User" ? ecard?.MessageTo : ecard?.MessageFrom}
                        </label>
                        <br />
                        <span className="text-muted msg-desc hidden-text">
                          {ecard?.EcardSubject}
                        </span>
                      </div>
                    </div>
                    <div className="justify-content-end">
                      <div>
                        <span className="text-muted float-right position-mobile">
                          {formatDateTime(ecard?.SentDate)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-end align-items-center flex-wrap ml-15">
                        {activeTab === "Public User" && (
                          <div className="col-status">
                            {ecard?.ReadStaus === "Read" ? (
                              <span className="tick-icon read" title={currentLang?.DropDown?.Read}><img src={messageRead}></img></span>
                            ) : (
                              <span className="tick-icon sent" title={currentLang?.DropDown?.Unread}><img src={messagesent}></img></span>
                            )}
                          </div>
                        )}

                        {(ecard.IsAllowSendReply === 1 && ecard?.Blocked === 0) && (
                          <button
                            id="btnBuyCredits"
                            type="button"
                            title={currentLang?.buttons?.BuyCredits}
                            className="btn btn-success btn-sm ml-10 pad-4"
                            onClick={(event) =>
                              handleClickRedirect(event, ecard?.InmateId)
                            }
                          >
                            {currentLang?.buttons?.BuyCredits}
                          </button>
                        )}

                        <div className="d-flex align-items-center justify-content-center ">
                          <button className="btn btn-blue btn-sm min-width-80 ml-15 cursor-default">
                            <h5 className="available-limit text-white">
                              $
                              {parseFloat(ecard.CreditAmount).toFixed(2) ||
                                "0.00"}
                            </h5>
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>
                ))
              )}

              {hasMoreData && filteredEcards?.length > 0 && (
                <li className="list-group-item">
                  <div className="d-flex justify-content-center mb-n3">
                    <div className="div-load-more-data inbox panel footer-load-more">
                      <label
                        className="text-decoration-none fs-5 cursor-pointer load-more load-more-button"
                        onClick={
                          isSearch ? () => handleSearch(true) : handleLoadMore
                        }
                      >
                        <i className="fa-solid fa-plus me-1 font-size-14"></i>
                        {currentLang?.buttons?.LoadMore}
                      </label>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </ul>
        </div>
      </div>

      {loader}
      <ConfirmationModal
        show={isPurchaseHistoryConfirm}
        onHide={handleCancelPurchaseHist}
        onConfirm={handleClickPurchaseCreditRedirect}
        title={currentLang?.Message}
        message={currentLang?.ArchivedPagePopContent?.Redirect_Page}
        closeButton={false}
        onconfirmname={currentLang?.buttons?.Yes}
        oncancelname={currentLang?.buttons?.No}
      />

      <ConfirmationModal
        show={isPaymentMsg}
        onHide={handlePaymentMsg}
        onConfirm={handlePaymentMsg}
        title={currentLang?.Message}
        message={paymentMsg}
        showCancelButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />
    </>
  );
};

export default React.memo(SendEcards);
